import script from "./FloatingTools.vue?vue&type=script&lang=ts&setup=true"
export * from "./FloatingTools.vue?vue&type=script&lang=ts&setup=true"

import "./FloatingTools.vue?vue&type=style&index=0&id=39206958&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39206958"]])

export default __exports__